import RouterService from "@/services/RouterService";

export default {
  namespaced: true,
  state: () => ({
    routersList: [],
    routersCount: 0,
  }),
  mutations: {
    setRoutersList: (state, data) => {
      state.routersList = data;
    },
    setRoutersCount: (state, data) => {
      state.routersCount = data;
    },
  },
  actions: {
    getRoutersList: ({ commit }, data) => {
      return new Promise((resolve, reject) => {
        RouterService.routersList(data)
          .then((res) => {
            if (res.status === 200) {
              commit("setRoutersList", res.data.list);
              commit("setRoutersCount", res.data.count);
            }
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};
